import { useBrokersServiceBrokersUsersListKey } from '@insurance/api/queries'
import { BrokersService } from '@insurance/api/requests'
import { InfiniteSelect } from '@shared/components'
import { usePermissionRestriction, useSessionContext } from '@shared/hooks'
import { AppPermissions } from '@shared/types'
import { getFullName } from '@shared/utils'
import { SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  ids?: string
  excludeIds?: string
  excludeStatus?: Array<'active' | 'deleted' | 'disabled' | 'pending'>
  teams?: string
  broker?: string
  permissions?: AppPermissions[]
} & SelectProps

export const BrokerUserSelect = ({
  ids,
  excludeIds,
  excludeStatus,
  teams,
  broker,
  permissions,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const { broker: appBroker } = useSessionContext()
  const { hasPermission } = usePermissionRestriction()

  if (
    appBroker
      ? !appBroker?.user?.is_broker_admin
      : !hasPermission([AppPermissions.NO_ORGANIZATION_LIMIT])
  )
    return null

  return (
    <InfiniteSelect
      placeholder={t('agent')}
      apiCall={({ pageParam, pageSize, search }) =>
        BrokersService.brokersUsersList(
          broker ? Number(broker) : undefined, // broker
          undefined, // email
          excludeIds, // excludeIds
          excludeStatus, // excludeStatus
          undefined, // identificationNumber
          ids, // ids
          undefined, // isBroker
          undefined, // isStaff
          undefined, // ordering
          undefined, // origin
          pageParam, // page
          pageSize, // pageSize
          permissions,
          search, // search
          undefined, // ssoId
          undefined, // status
          teams // teams
        )
      }
      queryKey={[
        useBrokersServiceBrokersUsersListKey,
        ids,
        excludeIds,
        excludeStatus,
        teams,
        broker,
        permissions
      ]}
      getOption={({ id, ...user }) => ({
        label: getFullName(user),
        value: String(id)
      })}
      {...props}
    />
  )
}
